// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import styles from './Tab.module.scss'

export const Tab = React.forwardRef(
  ({ children, className = undefined, id, onClick, isDisabled }, ref) => (
    <button
      className={cx(styles.tab, {
        [styles.disabled]: isDisabled,
        [className]: Boolean(className),
      })}
      data-testid="tab"
      id={id}
      ref={ref}
      onClick={onClick}
      disabled={isDisabled}
    >
      <span className={styles.content}>{children}</span>
    </button>
  ),
)
